const ALB_SELECTOR = ".alb";
const ALB_LINK_SELECTOR = ".alb--link";

/**
 * @file z
 * Global utilities.
 *
 */
(function ($, Drupal) {
  "use strict";

  Drupal.behaviors.accessible_link_box = {
    attach: function (context, settings) {
      context.querySelectorAll(ALB_SELECTOR).forEach((element) => {
        let link = element.querySelector(ALB_LINK_SELECTOR);
        let downTimestamp = new Date();

        /**
         * handleMouseDown
         */
        const handleMouseDown = (event) => {
          downTimestamp = new Date();
        };

        /**
         * handleMouseUp
         */
        const handleMouseUp = (event) => {
          let upTimestamp = new Date();
          if (upTimestamp - downTimestamp < 200) {
            if (!event.target.href) {
              link.click();
            }
          }
        };

        element.addEventListener("mousedown", handleMouseDown);
        element.addEventListener("mouseup", handleMouseUp);
      });
    },
  };
})(jQuery, Drupal, drupalSettings);
